import { useCallback, useEffect, useState } from "react";
import moment from "moment/moment";
import { MonthlyLottery } from "kadow-model-monthly-lottery";

const useGLM = (
  token: string | undefined,
  fetchGLM: (token: string) => Promise<MonthlyLottery[]>
) => {
  const [GLMList, setGLMList] = useState<MonthlyLottery[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getGLM = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      const nowTs = moment().unix();
      const res = await fetchGLM(token);
      const filtered = res.filter((r) => {
        return r.drawTs > nowTs && /^\d{4}-\d{2}$/.test(r._id);
      });
      setGLMList(filtered);
      setError(null);
    } catch (err) {
      // @ts-expect-error
      setError(err.message);
    }
  }, [token, fetchGLM]);

  useEffect(() => {
    void getGLM();
  }, [token]);

  return {
    GLMList,
    isLoading,
    error
  };
};

export default useGLM;
